import { useFormContext } from "react-hook-form";
import { Radio as MuRadio } from '@mui/material';

interface RadioProps {
  label: string;
  name: string;
  canBe: string;
}

const Radio = ({ label, name, canBe }: RadioProps) => {
  const { watch, setValue } = useFormContext()

  return (
    <label>
      {label}
      <MuRadio
        checked={watch(name) === canBe}
        onChange={() => setValue(name, canBe)}
        value={canBe}
        name={name}
      />
    </label>
  );
}

export default Radio;
